
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { cancelWarehouseSetup } from 'actions'
import { getWarehouseMetadataById } from 'selectors'
import Select from '../warehouse-setup-select'
import Connect from '../warehouse-setup-connect'
import Connecting from '../warehouse-setup-connecting'
import SetupError from '../warehouse-setup-error'
import Connected from '../warehouse-setup-finish'
import Setup from '../../components/warehouse-setup'

class WarehouseSetupAppContainer extends Component {
  render () {
    let content
    let databaseSelected = false
    let databaseConnected = false

    if (this.props.isConnecting || this.props.isCreating) {
      // if we're connecting to or creating a database
      databaseSelected = true
      databaseConnected = false
      content = <Connecting />
    } else if (this.props.didConnectionFail || this.props.didCreateFail) {
      // if we errored
      databaseSelected = true
      databaseConnected = false
      content = <SetupError workspaceSlug={this.props.workspaceSlug} />
    } else if (this.props.databaseSlug === 'bigquery' && this.props.didCreate) {
      // if we created a bigquery database
      databaseSelected = true
      databaseConnected = true
      content = <Connected workspaceSlug={this.props.workspaceSlug} />
    } else if (this.props.didConnect && this.props.didCreate) {
      // if we connected to and created a new database
      databaseSelected = true
      databaseConnected = true
      content = <Connected workspaceSlug={this.props.workspaceSlug} />
    } else if (this.props.databaseId && this.props.currentStep === 'connect') {
      // if we've selected a database type
      databaseSelected = true
      databaseConnected = false
      content = <Connect workspaceSlug={this.props.workspaceSlug} />
    } else {
      // undefined/default
      databaseSelected = false
      databaseConnected = false
      content = <Select workspaceSlug={this.props.workspaceSlug} />
    }

    return (
      <Setup
        workspaceSlug={this.props.workspaceSlug}
        isShowing={this.props.isShowing}
        databaseSelected={databaseSelected}
        databaseConnected={databaseConnected}
        cancelSetup={this.props.cancelSetup}>
        {content}
      </Setup>
    )
  }
}

function mapStateToProps (state) {
  const {
    databaseId,
    isConnecting,
    didConnectionFail,
    didConnect,
    isCreating,
    didCreate,
    didCreateFail,
    currentStep
  } = state.application.warehouseSetup

  const database = getWarehouseMetadataById(state, databaseId) || {}

  return {
    databaseId,
    databaseSlug: database.slug,
    isConnecting,
    didConnectionFail,
    didConnect,
    isCreating,
    didCreate,
    didCreateFail,
    currentStep
  }
}

function mapDispatchToProps (dispatch) {
  return {
    cancelSetup: function () {
      dispatch(cancelWarehouseSetup())
    }
  }
}

WarehouseSetupAppContainer.propTypes = {
  cancelSetup: PropTypes.func.isRequired,
  currentStep: PropTypes.string.isRequired,
  databaseId: PropTypes.string.isRequired,
  databaseSlug: PropTypes.string,
  didConnect: PropTypes.bool.isRequired,
  didConnectionFail: PropTypes.bool.isRequired,
  didCreate: PropTypes.bool.isRequired,
  didCreateFail: PropTypes.bool.isRequired,
  isConnecting: PropTypes.bool.isRequired,
  isCreating: PropTypes.bool.isRequired,
  isShowing: PropTypes.bool.isRequired,
  workspaceSlug: PropTypes.string.isRequired
}

WarehouseSetupAppContainer.displayName = 'WarehouseSetupAppContainer'

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupAppContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-app/index.js